export const CurrencyUnits = ['KRW', 'USD', 'EUR', 'JPY'] as const;
